// School Calendar Data - Hong Kong Academic Year 2024-2025
// Comprehensive event and holiday data for Hong Kong schools

// Event Categories
export const eventCategories = {
  academic: {
    id: 'academic',
    name: '學術活動',
    nameEn: 'Academic',
    color: '#3b82f6',
    icon: '📚'
  },
  examination: {
    id: 'examination',
    name: '考試',
    nameEn: 'Examination',
    color: '#ef4444',
    icon: '📝'
  },
  holiday: {
    id: 'holiday',
    name: '假期',
    nameEn: 'Holiday',
    color: '#10b981',
    icon: '🏖️'
  },
  sports: {
    id: 'sports',
    name: '體育活動',
    nameEn: 'Sports',
    color: '#f59e0b',
    icon: '🏃'
  },
  cultural: {
    id: 'cultural',
    name: '文化活動',
    nameEn: 'Cultural',
    color: '#8b5cf6',
    icon: '🎭'
  },
  administrative: {
    id: 'administrative',
    name: '行政事務',
    nameEn: 'Administrative',
    color: '#6b7280',
    icon: '📋'
  },
  parent: {
    id: 'parent',
    name: '家長活動',
    nameEn: 'Parent',
    color: '#ec4899',
    icon: '👨‍👩‍👧‍👦'
  },
  community: {
    id: 'community',
    name: '社區服務',
    nameEn: 'Community',
    color: '#06b6d4',
    icon: '🤝'
  }
};

// Event Types
export const eventTypes = {
  lesson: { id: 'lesson', name: '課程', nameEn: 'Lesson' },
  exam: { id: 'exam', name: '考試', nameEn: 'Exam' },
  holiday: { id: 'holiday', name: '假期', nameEn: 'Holiday' },
  activity: { id: 'activity', name: '活動', nameEn: 'Activity' },
  meeting: { id: 'meeting', name: '會議', nameEn: 'Meeting' },
  ceremony: { id: 'ceremony', name: '典禮', nameEn: 'Ceremony' },
  trip: { id: 'trip', name: '旅行', nameEn: 'Trip' },
  competition: { id: 'competition', name: '比賽', nameEn: 'Competition' },
  workshop: { id: 'workshop', name: '工作坊', nameEn: 'Workshop' },
  performance: { id: 'performance', name: '表演', nameEn: 'Performance' }
};

// Hong Kong Public Holidays 2024-2025
export const holidayCalendar = [
  // 2024 Holidays
  {
    id: 'holiday_2024_001',
    date: '2024-07-01',
    title: '香港特別行政區成立紀念日',
    titleEn: 'HKSAR Establishment Day',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2024_002',
    date: '2024-09-17',
    title: '中秋節翌日',
    titleEn: 'Day after Mid-Autumn Festival',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2024_003',
    date: '2024-10-01',
    title: '國慶日',
    titleEn: 'National Day',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2024_004',
    date: '2024-10-11',
    title: '重陽節',
    titleEn: 'Chung Yeung Festival',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2024_005',
    date: '2024-12-25',
    title: '聖誕節',
    titleEn: 'Christmas Day',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2024_006',
    date: '2024-12-26',
    title: '節禮日',
    titleEn: 'Boxing Day',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },

  // 2025 Holidays
  {
    id: 'holiday_2025_001',
    date: '2025-01-01',
    title: '元旦',
    titleEn: 'New Year\'s Day',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_002',
    date: '2025-01-29',
    title: '農曆新年初一',
    titleEn: 'Lunar New Year Day 1',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_003',
    date: '2025-01-30',
    title: '農曆新年初二',
    titleEn: 'Lunar New Year Day 2',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_004',
    date: '2025-01-31',
    title: '農曆新年初三',
    titleEn: 'Lunar New Year Day 3',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_005',
    date: '2025-04-04',
    title: '清明節',
    titleEn: 'Ching Ming Festival',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_006',
    date: '2025-04-18',
    title: '耶穌受難節',
    titleEn: 'Good Friday',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_007',
    date: '2025-04-19',
    title: '耶穌受難節翌日',
    titleEn: 'Day after Good Friday',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_008',
    date: '2025-04-21',
    title: '復活節星期一',
    titleEn: 'Easter Monday',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_009',
    date: '2025-05-01',
    title: '勞動節',
    titleEn: 'Labour Day',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_010',
    date: '2025-05-05',
    title: '佛誕',
    titleEn: 'Buddha\'s Birthday',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_011',
    date: '2025-06-02',
    title: '端午節',
    titleEn: 'Dragon Boat Festival',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  },
  {
    id: 'holiday_2025_012',
    date: '2025-07-01',
    title: '香港特別行政區成立紀念日',
    titleEn: 'HKSAR Establishment Day',
    type: 'holiday',
    category: 'holiday',
    isPublicHoliday: true,
    duration: 1
  }
];

// Academic Calendar Events
export const academicCalendar = [
  // September 2024 - Term 1 Start
  {
    id: 'academic_2024_001',
    date: '2024-09-02',
    title: '新學年開學典禮',
    titleEn: 'School Opening Ceremony',
    type: 'ceremony',
    category: 'academic',
    description: '2024-2025學年開學典禮，歡迎新生及家長參與',
    targetAudience: ['全校', '家長'],
    duration: 2,
    location: '學校禮堂'
  },
  {
    id: 'academic_2024_002',
    date: '2024-09-03',
    title: '正式上課開始',
    titleEn: 'Regular Classes Begin',
    type: 'lesson',
    category: 'academic',
    description: '新學年正式上課開始',
    targetAudience: ['全校'],
    duration: 1
  },
  {
    id: 'academic_2024_003',
    date: '2024-09-07',
    title: '家長日 - 中一迎新',
    titleEn: 'Parent Day - Form 1 Orientation',
    type: 'meeting',
    category: 'parent',
    description: '中一新生家長迎新活動及家長會',
    targetAudience: ['中一', '家長'],
    duration: 3,
    location: '各班課室'
  },

  // October 2024
  {
    id: 'academic_2024_004',
    date: '2024-10-15',
    title: '第一次統測',
    titleEn: 'First Uniform Test',
    type: 'exam',
    category: 'examination',
    description: '第一學期第一次統一測驗',
    targetAudience: ['全校'],
    duration: 5,
    examType: 'uniform_test'
  },
  {
    id: 'academic_2024_005',
    date: '2024-10-25',
    title: '校運會',
    titleEn: 'Sports Day',
    type: 'competition',
    category: 'sports',
    description: '年度校際運動會',
    targetAudience: ['全校', '家長'],
    duration: 1,
    location: '運動場'
  },

  // November 2024
  {
    id: 'academic_2024_006',
    date: '2024-11-08',
    title: '家長日',
    titleEn: 'Parent-Teacher Conference',
    type: 'meeting',
    category: 'parent',
    description: '全校家長日及學生成績檢討',
    targetAudience: ['全校', '家長'],
    duration: 1,
    location: '各班課室'
  },
  {
    id: 'academic_2024_007',
    date: '2024-11-20',
    title: '中六模擬考試',
    titleEn: 'Form 6 Mock Exam',
    type: 'exam',
    category: 'examination',
    description: '中六學生DSE模擬考試',
    targetAudience: ['中六'],
    duration: 10,
    examType: 'mock_exam'
  },

  // December 2024
  {
    id: 'academic_2024_008',
    date: '2024-12-10',
    title: '聖誕聯歡會',
    titleEn: 'Christmas Celebration',
    type: 'activity',
    category: 'cultural',
    description: '全校聖誕聯歡活動',
    targetAudience: ['全校'],
    duration: 1,
    location: '學校禮堂'
  },
  {
    id: 'academic_2024_009',
    date: '2024-12-16',
    title: '第一學期考試',
    titleEn: 'First Term Examination',
    type: 'exam',
    category: 'examination',
    description: '第一學期期末考試',
    targetAudience: ['全校'],
    duration: 8,
    examType: 'term_exam'
  },

  // January 2025
  {
    id: 'academic_2025_001',
    date: '2025-01-15',
    title: '中六畢業照拍攝',
    titleEn: 'Form 6 Graduation Photo',
    type: 'activity',
    category: 'academic',
    description: '中六學生畢業照拍攝',
    targetAudience: ['中六'],
    duration: 1,
    location: '學校操場'
  },

  // February 2025
  {
    id: 'academic_2025_002',
    date: '2025-02-17',
    title: '第二學期開學',
    titleEn: 'Second Term Begins',
    type: 'lesson',
    category: 'academic',
    description: '農曆新年假期後復課',
    targetAudience: ['全校'],
    duration: 1
  },

  // March 2025
  {
    id: 'academic_2025_003',
    date: '2025-03-15',
    title: '第二次統測',
    titleEn: 'Second Uniform Test',
    type: 'exam',
    category: 'examination',
    description: '第二學期第一次統一測驗',
    targetAudience: ['全校'],
    duration: 5,
    examType: 'uniform_test'
  },
  {
    id: 'academic_2025_004',
    date: '2025-03-25',
    title: '數學週',
    titleEn: 'Mathematics Week',
    type: 'activity',
    category: 'academic',
    description: '數學科主題週活動',
    targetAudience: ['全校'],
    duration: 5,
    location: '各課室及禮堂'
  },

  // April 2025
  {
    id: 'academic_2025_005',
    date: '2025-04-08',
    title: '中六畢業典禮',
    titleEn: 'Form 6 Graduation Ceremony',
    type: 'ceremony',
    category: 'academic',
    description: '中六學生畢業典禮',
    targetAudience: ['中六', '家長', '教師'],
    duration: 2,
    location: '學校禮堂'
  },

  // May 2025
  {
    id: 'academic_2025_006',
    date: '2025-05-12',
    title: '英語週',
    titleEn: 'English Week',
    type: 'activity',
    category: 'academic',
    description: '英文科主題週活動',
    targetAudience: ['全校'],
    duration: 5,
    location: '各課室及禮堂'
  },
  {
    id: 'academic_2025_007',
    date: '2025-05-20',
    title: '家長日',
    titleEn: 'Parent-Teacher Conference',
    type: 'meeting',
    category: 'parent',
    description: '第二學期家長日',
    targetAudience: ['全校', '家長'],
    duration: 1,
    location: '各班課室'
  },

  // June 2025
  {
    id: 'academic_2025_008',
    date: '2025-06-10',
    title: '第二學期考試',
    titleEn: 'Second Term Examination',
    type: 'exam',
    category: 'examination',
    description: '第二學期期末考試',
    targetAudience: ['中一至中五'],
    duration: 8,
    examType: 'term_exam'
  },
  {
    id: 'academic_2025_009',
    date: '2025-06-25',
    title: '散學典禮',
    titleEn: 'End of Year Ceremony',
    type: 'ceremony',
    category: 'academic',
    description: '學年結束典禮及暑假開始',
    targetAudience: ['全校'],
    duration: 1,
    location: '學校禮堂'
  },

  // July 2025
  {
    id: 'academic_2025_010',
    date: '2025-07-15',
    title: '暑期補課開始',
    titleEn: 'Summer Classes Begin',
    type: 'lesson',
    category: 'academic',
    description: '暑期補習課程開始',
    targetAudience: ['報名學生'],
    duration: 20,
    location: '指定課室'
  }
];

// School Events (Sports, Cultural, Community)
export const schoolEvents = [
  // Sports Events
  {
    id: 'sports_2024_001',
    date: '2024-09-20',
    title: '校際游泳比賽',
    titleEn: 'Inter-school Swimming Competition',
    type: 'competition',
    category: 'sports',
    description: '參加區內校際游泳比賽',
    targetAudience: ['游泳隊'],
    duration: 1,
    location: '區內游泳池'
  },
  {
    id: 'sports_2024_002',
    date: '2024-10-05',
    title: '籃球友誼賽',
    titleEn: 'Basketball Friendly Match',
    type: 'competition',
    category: 'sports',
    description: '與友校籃球友誼賽',
    targetAudience: ['籃球隊'],
    duration: 1,
    location: '學校籃球場'
  },
  {
    id: 'sports_2025_001',
    date: '2025-03-10',
    title: '田徑錦標賽',
    titleEn: 'Athletics Championship',
    type: 'competition',
    category: 'sports',
    description: '區內田徑錦標賽',
    targetAudience: ['田徑隊'],
    duration: 1,
    location: '區內運動場'
  },

  // Cultural Events
  {
    id: 'cultural_2024_001',
    date: '2024-11-15',
    title: '中華文化日',
    titleEn: 'Chinese Culture Day',
    type: 'activity',
    category: 'cultural',
    description: '中華文化體驗活動',
    targetAudience: ['全校'],
    duration: 1,
    location: '全校'
  },
  {
    id: 'cultural_2025_001',
    date: '2025-04-22',
    title: '才藝表演',
    titleEn: 'Talent Show',
    type: 'performance',
    category: 'cultural',
    description: '學生才藝表演活動',
    targetAudience: ['全校', '家長'],
    duration: 2,
    location: '學校禮堂'
  },
  {
    id: 'cultural_2025_002',
    date: '2025-05-30',
    title: '音樂會',
    titleEn: 'School Concert',
    type: 'performance',
    category: 'cultural',
    description: '學校年度音樂會',
    targetAudience: ['全校', '家長'],
    duration: 2,
    location: '學校禮堂'
  },

  // Community Service
  {
    id: 'community_2024_001',
    date: '2024-10-30',
    title: '社區清潔日',
    titleEn: 'Community Clean-up Day',
    type: 'activity',
    category: 'community',
    description: '學生參與社區清潔服務',
    targetAudience: ['義工學生'],
    duration: 1,
    location: '學校附近社區'
  },
  {
    id: 'community_2025_001',
    date: '2025-02-28',
    title: '長者探訪',
    titleEn: 'Elderly Visit',
    type: 'activity',
    category: 'community',
    description: '探訪區內長者中心',
    targetAudience: ['義工學生'],
    duration: 1,
    location: '長者中心'
  },

  // Administrative Events
  {
    id: 'admin_2024_001',
    date: '2024-09-10',
    title: '教師專業發展日',
    titleEn: 'Teacher Professional Development Day',
    type: 'workshop',
    category: 'administrative',
    description: '教師專業培訓活動（學生停課）',
    targetAudience: ['教師'],
    duration: 1,
    location: '學校會議室'
  },
  {
    id: 'admin_2025_001',
    date: '2025-01-20',
    title: '校務會議',
    titleEn: 'School Board Meeting',
    type: 'meeting',
    category: 'administrative',
    description: '學校管理委員會會議',
    targetAudience: ['管理層'],
    duration: 0.5,
    location: '校長室'
  }
];

// Helper Functions
export const getEventsByDate = (date) => {
  const allEvents = [...holidayCalendar, ...academicCalendar, ...schoolEvents];
  return allEvents.filter(event => event.date === date);
};

export const getEventsByMonth = (year, month) => {
  const monthStr = `${year}-${String(month).padStart(2, '0')}`;
  const allEvents = [...holidayCalendar, ...academicCalendar, ...schoolEvents];
  return allEvents.filter(event => event.date.startsWith(monthStr));
};

export const getEventsByCategory = (categoryId) => {
  const allEvents = [...holidayCalendar, ...academicCalendar, ...schoolEvents];
  return allEvents.filter(event => event.category === categoryId);
};

export const getEventsByType = (typeId) => {
  const allEvents = [...holidayCalendar, ...academicCalendar, ...schoolEvents];
  return allEvents.filter(event => event.type === typeId);
};

export const getHolidaysByMonth = (year, month) => {
  const monthStr = `${year}-${String(month).padStart(2, '0')}`;
  return holidayCalendar.filter(holiday => holiday.date.startsWith(monthStr));
};

export const getAcademicEventsByTerm = (term) => {
  // Term 1: September - January, Term 2: February - June
  if (term === 1) {
    return academicCalendar.filter(event => {
      const month = parseInt(event.date.split('-')[1]);
      return month >= 9 || month <= 1;
    });
  } else if (term === 2) {
    return academicCalendar.filter(event => {
      const month = parseInt(event.date.split('-')[1]);
      return month >= 2 && month <= 6;
    });
  }
  return academicCalendar;
};

export const isSchoolHoliday = (date) => {
  return holidayCalendar.some(holiday => holiday.date === date);
};

export const getNextEvent = (fromDate = new Date()) => {
  const allEvents = [...holidayCalendar, ...academicCalendar, ...schoolEvents];
  const futureEvents = allEvents.filter(event => new Date(event.date) > fromDate);
  return futureEvents.sort((a, b) => new Date(a.date) - new Date(b.date))[0];
};

export const getUpcomingEvents = (fromDate = new Date(), limit = 10) => {
  const allEvents = [...holidayCalendar, ...academicCalendar, ...schoolEvents];
  const futureEvents = allEvents.filter(event => new Date(event.date) > fromDate);
  return futureEvents.sort((a, b) => new Date(a.date) - new Date(b.date)).slice(0, limit);
}; 